export default __webpack_public_path__ + "static/media/menu.0e406562.svg";